const LAST_ERROR_TIMEOUT = 1000 * 2; // 2 seconds

export const duplicateErrorHelper = () => {
  const lastError: {
    errorData: any;
    lastLoggedTime: number | null;
  } = {
    errorData: null,
    lastLoggedTime: null,
  };

  const isDuplicateError = (errorData: any) =>
    lastError.lastLoggedTime &&
    Date.now() - lastError.lastLoggedTime < LAST_ERROR_TIMEOUT &&
    JSON.stringify(lastError.errorData) === JSON.stringify(errorData);

  const setNewLastError = (errorData: any) => {
    lastError.errorData = errorData;
    lastError.lastLoggedTime = Date.now();
  };

  return {
    isDuplicateError,
    setNewLastError,
  };
};
